import { eTipoPermissao } from '@/enums/ePermissoes';
import {
  eAbrangenciaGerador,
  eTipoGerador,
} from '@/models/ferramentas/gerador-relatorios.model';

/*
 * GERADOR DE RELATÓRIOS — migração de `GeradorDeRelatorios.aspx`,
 * `GeradorDeRelatoriosPessoal.aspx`, `GeradorDeRelatoriosGestao.aspx` e
 * `GeradorDeRelatoriosPessoalGestao.aspx`.
 *
 * QUATRO ROTAS, DUAS TELAS. No legado eram quatro telas, mas duas delas eram cópias das outras
 * com um filtro a mais: as do menu Acadêmico viam a escola, as do menu Gestão viam a rede. Aqui a
 * tela é a mesma e a diferença está em `meta.abrangencia`.
 *
 * As quatro rotas existem porque são QUATRO PERMISSÕES: a rede precisa poder liberar a visão da
 * rede a quem ela decidir sem liberar a da escola junto — e vice-versa. E porque o menu do legado
 * abre a tela nova por `/proxylegado/<nome>`, em que a query string não atravessa: um
 * `?abrangencia=1` chegaria vazio do outro lado.
 *
 * O `INSERT` na Seg_Menu está em
 * `saeweb-database-sql/consultebase/scripts/2026-09-23-Permissoes-GeradorRelatorios.sql`.
 */
export default [
  {
    description: 'Gerador de Relatórios — Estudantes',
    path: '/ferramentas/geradorrelatorios/estudantes',
    name: 'gerador_relatorios_estudantes',
    component: () => import('@/views/ferramentas/geradorrelatorios/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ESTUDANTESNOVO_MENU_300803799],
      tipoGerador: eTipoGerador.Estudantes,
      abrangencia: eAbrangenciaGerador.Escola,
    },
    goesToMenu: true,
  },
  {
    description: 'Gerador de Relatórios — Funcionários',
    path: '/ferramentas/geradorrelatorios/funcionarios',
    name: 'gerador_relatorios_funcionarios',
    component: () => import('@/views/ferramentas/geradorrelatorios/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.FUNCIONARIOSNOVO_MENU_300803798],
      tipoGerador: eTipoGerador.Funcionarios,
      abrangencia: eAbrangenciaGerador.Escola,
    },
    goesToMenu: true,
  },
  {
    description: 'Gerador de Relatórios da Rede — Estudantes',
    path: '/ferramentas/geradorrelatorios/rede/estudantes',
    name: 'gerador_relatorios_estudantes_rede',
    component: () => import('@/views/ferramentas/geradorrelatorios/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ESTUDANTESGESTAONOVO_MENU_1700400099],
      tipoGerador: eTipoGerador.Estudantes,
      abrangencia: eAbrangenciaGerador.Rede,
    },
    goesToMenu: true,
  },
  {
    description: 'Gerador de Relatórios da Rede — Funcionários',
    path: '/ferramentas/geradorrelatorios/rede/funcionarios',
    name: 'gerador_relatorios_funcionarios_rede',
    component: () => import('@/views/ferramentas/geradorrelatorios/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.FUNCIONARIOSGESTAONOVO_MENU_1700400098],
      tipoGerador: eTipoGerador.Funcionarios,
      abrangencia: eAbrangenciaGerador.Rede,
    },
    goesToMenu: true,
  },
];
